// enrollments.js (em migração do global.js)

import { getOptionsFromMap } from './common';

export const MEMBERSHIP_STATUS = {
    ACTIVE: 'active',
    SUSPENDED: 'suspended',
    CANCELED: 'canceled',
    EXPIRED: 'expired'
};

export const MEMBERSHIP_STATUS_LABELS = {
    [MEMBERSHIP_STATUS.ACTIVE]: 'Ativo',
    [MEMBERSHIP_STATUS.SUSPENDED]: 'Suspenso',
    [MEMBERSHIP_STATUS.CANCELED]: 'Cancelado',
    [MEMBERSHIP_STATUS.EXPIRED]: 'Vencido'
};

export const MEMBERSHIP_STATUS_OPTIONS = getOptionsFromMap(MEMBERSHIP_STATUS, MEMBERSHIP_STATUS_LABELS);

export const ENROLLMENT_TYPES = {
    REGULAR: 'regular',
    TRIAL: 'trial',
    MAKEUP: 'makeup',
    SINGLE: 'single'
};

export const ENROLLMENT_TYPE_LABELS = {
    [ENROLLMENT_TYPES.REGULAR]: 'Regular',
    [ENROLLMENT_TYPES.TRIAL]: 'Experimental',
    [ENROLLMENT_TYPES.MAKEUP]: 'Reposição',
    [ENROLLMENT_TYPES.SINGLE]: 'Avulsa'
};

export const ENROLLMENT_TYPE_OPTIONS = getOptionsFromMap(ENROLLMENT_TYPES, ENROLLMENT_TYPE_LABELS);

export const ENROLLMENT_STATUS = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    CANCELED: 'canceled',
    COMPLETED: 'completed'
};

export const ENROLLMENT_STATUS_LABELS = {
    [ENROLLMENT_STATUS.ACTIVE]: 'Ativo',
    [ENROLLMENT_STATUS.PAUSED]: 'Pausado',
    [ENROLLMENT_STATUS.CANCELED]: 'Cancelado',
    [ENROLLMENT_STATUS.COMPLETED]: 'Concluído'
};

export const ENROLLMENT_STATUS_OPTIONS = getOptionsFromMap(ENROLLMENT_STATUS, ENROLLMENT_STATUS_LABELS);

export const TRIAL_ATTENDANCE_STATUS = {
    PENDING: 'PENDING',
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT'
};

export const TRIAL_ATTENDANCE_STATUS_LABELS = {
    [TRIAL_ATTENDANCE_STATUS.PENDING]: 'Agendado',
    [TRIAL_ATTENDANCE_STATUS.PRESENT]: 'Presente',
    [TRIAL_ATTENDANCE_STATUS.ABSENT]: 'Faltou'
};
